module.exports = __webpack_public_path__ + "static/media/TickMark.20710820.svg";